import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar } from '@fullcalendar/core';

export function initCalLogEntries(cal: Calendar) {
  p('initCalLogEntries');

  const calendar = cal;
  Cookies.set('launch_area_back', window.location.href, { path: '/' });

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default btn-sm margin-5px',
    html: '<i class="fa fa-pencil-square-o"></i> Bejegyzések'
  });
  $('#btnContainer').append(btn);

  const source = calendar.addEventSource({
    url: '/log_entries.json',
    extraParams: {
      'q[launch_areas_id_eq]': $('#q_launch_area_id_eq').val()
    }
  });
  source.remove();

  let active = !(Cookies.get('cal_no_log_entries') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.css('background-color', '#d9ebf2') : btn.css('background-color', 'white');
    active ? calendar.addEventSource(source) : source.remove();
    Cookies.set('cal_no_log_entries', (!active) + '', {
      expires: 10,
      path: '/'
    });
  }

}